// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Dropdown-module--cls1--Cq2uP","cls2":"Dropdown-module--cls2--3Flho Dropdown-module--cls1--Cq2uP"};